import styled from 'styled-components';

export const TermsAndConditionsModalContainer = styled.div`
	width: 600px;
	height: 557px;
	margin: 0 auto;
	z-index: 4;
`;
